import CheckIcon from "@mui/icons-material/Check";
import { Box, Button } from "@mui/material";
import React from "react";

/**
 * Component for displaying error selection and resolution buttons
 */
function ErrorButtons({ selectAllErrors, selectedErrorIds, showAlert, setDialogBoxOpen }) {
  return (
    <Box display={"flex"} justifyContent="end" sx={{ mb: 4 }}>
      <Button variant="outlined" color="inherit" sx={{ px: 2, py: 1, mx: 1 }} onClick={selectAllErrors}>
        Select All Errors
      </Button>

      <Button
        variant="outlined"
        color="inherit"
        startIcon={<CheckIcon />}
        sx={{ px: 2, py: 1, mx: 1 }}
        onClick={() => {
          if (selectedErrorIds.length === 0) {
            showAlert("error", "No Errors Selected!");
          } else {
            // closeAlert();
            setDialogBoxOpen(true);
          }
        }}
      >
        Resolve Errors
      </Button>
    </Box>
  );
}

export default ErrorButtons;
